import { FormControl } from "@angular/forms";
import { addDays, addYears, subYears } from "date-fns";
import { quickSelectionRanges } from './utils/quick-selection-ranges';
import { RadioOption } from '@rx-applications/shared/utils';

export interface DatePickerDateType extends RadioOption {
  id: string;
  key?: string; // used for translation when appliocable
}

export interface DatePickerAdvancedChanges {
  endDate: string;
  startDate: string;
  dateType: string| null;
}

export interface DatePickerForm {
  leftMonth: FormControl<number>;
  leftYear: FormControl<number>;
  rightMonth: FormControl<number>;
  rightYear: FormControl<number>;
}

export type FormControlDirection = 'left' | 'right';

export interface DatePickerRange {
  days: string;
  label: string;
}

export interface DatePickerAdvancedLocale {
  inputLabel: string
  dateTypeLabel: string;
  applyLabel: string;
  cancelLabel: string;
  customRangeLabel: string;
  monthLabel: string;
  quarterLabel: string;
  ranges: DatePickerRange[];
}

export interface DatePickerAdvancedRange {
  startDate: Date | string;
  endDate: Date | string;
  minDate: Date | string;
  maxDate: Date | string;
  dateType?: string;
}

export const DefaultLocale: DatePickerAdvancedLocale = {
  inputLabel: 'Date',
  dateTypeLabel: 'Date type',
  customRangeLabel: 'Custom range',
  monthLabel: 'Months',
  quarterLabel: 'Custom range',
  applyLabel: 'Apply',
  cancelLabel: 'Reset',
  ranges: quickSelectionRanges(
      {
        today: 'Today',
        sevenDays: 'Last 7 days',
        thirtyDays: 'Last 30 days',
        sixtyDays: 'Last 60 days',
        ninetyDays: 'Last 90 days'
      }
  )
};
export const DefaultRange: DatePickerAdvancedRange = {
  startDate: new Date(),
  endDate: addDays(new Date(), 1),
  minDate: subYears(new Date(), 3),
  maxDate: addYears(new Date(), 3),
}

export interface DatePickerLocale {
  general: DatePickerGeneralLocale;
  ranges: DateRangeLocale;
  dateType: DateTypeLocale;
}
export interface DatePickerGeneralLocale {
  label?: string;
  format: string;
  separator: string;
  applyLabel: string;
  cancelLabel: string;
  fromLabel: string;
  toLabel: string;
  customRangeLabel: string;
  monthLabel: string;
  quarterLabel: string;
  daysOfWeek: string[];
  monthNames: string[];
  firstDay: number;
}
export interface DateRangeLocale {
  today: string;
  sevenDays: string;
  thirtyDays: string;
  sixtyDays: string;
  ninetyDays: string;
}
export interface DateTypeLocale {
  title: string;
}
export interface DateTypeOption {
  key: string;
  name: string;
}

export interface DatepickerPeriod {
  year: number,
  months: DatepickerMonth[]
}
export interface DatepickerMonth {
  year: number;
  month: number;
  id: string;
  selected?: boolean;
  inRange?: boolean;
}

export interface DatepickerInterval {
  startDate: Date;
  endDate: Date;
}
